export default "<div class=\"tc-long-text\" [style.width]=\"width\">\r\n  {{ text }}\r\n</div>\r\n";